import type { WordLevel } from "#word-level";
import { HARDCODED_PRONUNCIATION_LEVEL_WORD_FORMS } from "#hardcoded-pronunciation-levels";

/**
 * Drop words that are already authored on a pronunciation level (3-P3's 个子 / 这个). They remain on
 * that authored P-level, never inside a generated HSK `N-Wk` batch.
 *
 * @param embeddedWordForms - defaults to the compiled P-level word list; `_generate-levels`
 *   passes a live read from the level files so authoring changes are respected immediately.
 */
export function withoutHardcodedPronunciationLevelWords(
  levels: readonly WordLevel[],
  embeddedWordForms: readonly string[] = HARDCODED_PRONUNCIATION_LEVEL_WORD_FORMS,
): WordLevel[] {
  if (embeddedWordForms.length === 0) {
    return [...levels];
  }
  const embedded = new Set(embeddedWordForms);
  const kept = levels
    .map((level) => ({
      ...level,
      words: level.words.filter((word) => !embedded.has(word)),
    }))
    .filter((level) => level.words.length > 0);
  // Re-index and recompute per-character-level sublevels after removals.
  const sublevelByCharacterLevel = new Map<number, number>();
  return kept.map((level, index) => {
    const sublevel = (sublevelByCharacterLevel.get(level.characterLevelIndex) ?? 0) + 1;
    sublevelByCharacterLevel.set(level.characterLevelIndex, sublevel);
    return { ...level, index, sublevel };
  });
}
